<template>
  <router-view />
</template>

<script>
export default {
  data() {
    return {
      isDark: true
    };
  },
  mounted() {
    this.isDark = localStorage.getItem("theme") === "dark";
    document.body.classList.toggle("dark", this.isDark);
  },
  methods: {
    toggleTheme() {
      this.isDark = !this.isDark;
      document.body.classList.toggle("dark", this.isDark);
      localStorage.setItem("theme", this.isDark ? "dark" : "light");
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}


</style>
